import { TextField, MenuItem, Button, FormControl, FormLabel } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const ImageAnalysisForm = () => {
  const [imageAnalysisFormData, setImageAnalysisFormData] = useState({
    image_path: "",
    analysis_type: "",
    model_name: "",
    output_format: "JSON",
  });

  const analysisTypeOptions = ["Material", "Color", "Object Detection", "Layout Recognition"];
  const modelNameOptions = ["Model A", "Model B", "Model C"];
  const outputFormatOptions = ["JSON", "XML", "CSV"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setImageAnalysisFormData({
      ...imageAnalysisFormData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(imageAnalysisFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Image Path</FormLabel>
            <TextField name="image_path" value={imageAnalysisFormData.image_path} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Analysis Type</FormLabel>
            <TextField select name="analysis_type" value={imageAnalysisFormData.analysis_type} onChange={handleChange}>
              {analysisTypeOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Model Name</FormLabel>
            <TextField select name="model_name" value={imageAnalysisFormData.model_name} onChange={handleChange}>
              {modelNameOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Output Format</FormLabel>
            <TextField select name="output_format" value={imageAnalysisFormData.output_format} onChange={handleChange}>
              {outputFormatOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ImageAnalysisForm;
